var map = {
	"./glyph-0.png": 690521,
	"./glyph-1.png": 609968,
	"./glyph-2.png": 363467,
	"./glyph-3.png": 142338,
	"./glyph-4.png": 538685,
	"./glyph-5.png": 317556,
	"./glyph-6.png": 536463,
	"./glyph-7.png": 497446,
	"./glyph-8.png": 253601,
	"./glyph-9.png": 768984,
	"./glyph-comma.png": 633880,
	"./glyph-dot.png": 193368,
	"./icon-gold-coin.png": 306058,
	"./icon-silver-coin.png": 969213,
	"./icon-usd-stack.png": 444881,
	"./img-btn-cta.png": 179139,
	"./img-modal-shell.png": 134412,
	"./img-value-highlight-bar.png": 434790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959031;